"use client";
import React from "react";
import { ReserveFieldDateMultiple } from "@/features/reserve/components/ReserveFieldDateMultiple/ReserveFieldDateMultiple";
import { ReserveFieldStartDate } from "@/features/reserve/components/ReserveFieldStartDate/ReserveFieldStartDate";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { useAuthenticated } from "@gettactic/hooks";
import { getReservationExtensionDays } from "@gettactic/helpers/src/resources/defines";

export const ReserveFormDates: React.FC = () => {
  const {
    office,
    isMeetingRoom,
    form,
    weekDates,
    currentOfficeTz,
    resourceType,
    startTime,
    allowOthers
  } = useReserveForm();
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const extraDays = getReservationExtensionDays(authenticatedUser?.user?.email);

  return (
    <div className="">
      {office ? (
        !isMeetingRoom ? (
          <ReserveFieldDateMultiple
            form={form}
            weekDates={weekDates}
            officeTimeZone={currentOfficeTz}
            errors={form.formState.errors}
            resType={resourceType}
            office={office}
            isAdmin={allowOthers}
            extraDays={extraDays}
          />
        ) : (
          <ReserveFieldStartDate
            form={form}
            defaultValue={weekDates}
            startTime={startTime}
            weekDates={weekDates}
            officeTimeZone={currentOfficeTz}
            errors={form.formState.errors}
            resType={resourceType}
            office={office}
            isAdmin={allowOthers}
            extraDays={extraDays}
          />
        )
      ) : null}
    </div>
  );
};
